document.addEventListener("alpine:init", () => {
  Alpine.data("horizontalScroller", function (data) {
    return {
      scrollPos: 0,
      hasReachedEnd: false,
      needsScroll: false,
      scrollDistance: 200,
      init() {
        this.$nextTick(() => {
          this.scrollDetecter();
        });
      },
      scrollNext() {
        this.$refs[data].scrollTo({
          top: 0,
          left: this.$refs[data].scrollLeft + this.scrollDistance,
          behavior: "smooth",
        });
        this.scrollDetecter();
      },
      scrollPrev() {
        this.$refs[data].scrollTo({
          top: 0,
          left: this.$refs[data].scrollLeft - this.scrollDistance,
          behavior: "smooth",
        });
        this.scrollDetecter();
      },
      scrollDetecter() {
        const div = this.$refs[data];
        if (div) {
          this.scrollPos = div.scrollLeft;
          if (div.scrollWidth > div.offsetWidth) {
            this.needsScroll = true;
          }
          if (div.scrollLeft + div.offsetWidth >= div.scrollWidth) {
            this.hasReachedEnd = true;
          } else {
            this.hasReachedEnd = false;
          }
        }
      },
    };
  });
});
